export default __webpack_public_path__ + "static/media/smiley_rating_bad.96ab223d.svg";